import {
  ChangeEvent,
  SyntheticEvent,
  useContext,
  useEffect,
  useState,
} from "react";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { Card } from "primereact/card";
import { userContext } from "../../context/user";
import commonStyles from "../common.module.css";
import { AuthLoginPayload } from "../../api/types/auth";
import { FormErrors } from "../../api/types/base";
import { classNames } from "primereact/utils";
import { NavLink, useSearchParams } from "react-router-dom";
import { Message } from "primereact/message";

export default function AuthLogin() {
  const [URLSearchParams] = useSearchParams();
  const { login } = useContext(userContext);

  const [emailVerified, setEmailVerified] = useState<number | null>(null);

  const [username, setUsername] = useState<string>("");
  const handleUsernameChange = (event: ChangeEvent<HTMLInputElement>) =>
    setUsername(event.target.value);

  const [password, setPassword] = useState<string>("");
  const handlePasswordChange = (event: ChangeEvent<HTMLInputElement>) =>
    setPassword(event.target.value);

  const [isPassVisible, setIsPassVisible] = useState(false);
  const handleIsPassVisibleChange = () => setIsPassVisible(!isPassVisible);

  const [errors, setErrors] = useState<FormErrors<AuthLoginPayload>>();
  const validate = (): boolean => {
    let newErrors: FormErrors<AuthLoginPayload> = {};

    if (!username) {
      newErrors.username = "";
    }

    if (!password) {
      newErrors.password = "";
    }

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (event: SyntheticEvent) => {
    event.preventDefault();

    if (!validate()) {
      return;
    }

    login({ username, password });
  };

  useEffect(() => {
    if (URLSearchParams.has("emailVerified")) {
      const value = parseInt(URLSearchParams.get("emailVerified") || "", 10);

      if (!isNaN(value)) {
        setEmailVerified(value);
      }
    }
  }, [URLSearchParams]);

  const footer = () => (
    <div className="text-center">
      <small className="block">
        Don't have an account yet?{" "}
        <NavLink to={"/registration"}>Register</NavLink>.
      </small>
      <small className="block">
        <NavLink to={"/reset-password"}>Forgotten password?</NavLink>
      </small>
      <small className="block">
        <NavLink to={"/email-verification"}>
          Resend verification e-mail.
        </NavLink>
      </small>
    </div>
  );

  return (
    <form className={"col-12 p-fluid"} onSubmit={handleSubmit}>
      <Card
        title={"Sign in"}
        className={"col-12 md:col-4 md:col-offset-4"}
        footer={footer}
      >
        <div className={"field"}>
          {emailVerified === 1 && (
            <Message
              severity="success"
              text="E-mail has been successfully verified. You can now sign in."
            />
          )}

          {emailVerified === 0 && (
            <Message
              severity="error"
              text="The e-mail could not be verified."
            />
          )}
        </div>

        <div className={"field"}>
          <label className={commonStyles.labelRequired}>E-mail:</label>
          <InputText
            value={username}
            onChange={handleUsernameChange}
            name={"email"}
            autoComplete={"on"}
            className={classNames({
              "p-invalid": errors?.hasOwnProperty("username"),
            })}
          />
        </div>

        <div className={"field"}>
          <label className={commonStyles.labelRequired}>Password:</label>
          <div className={"p-inputgroup"}>
            <InputText
              type={isPassVisible ? "text" : "password"}
              value={password}
              onChange={handlePasswordChange}
              className={classNames({
                "p-invalid": errors?.hasOwnProperty("password"),
              })}
            />
            <Button
              type={"button"}
              icon={isPassVisible ? "pi pi-eye-slash" : "pi pi-eye"}
              className={"p-button-secondary"}
              onClick={handleIsPassVisibleChange}
            />
          </div>
        </div>

        <Button label={"Sign in"} />
      </Card>
    </form>
  );
}
